import Box from '@material-ui/core/Box';
import {
  SEARCH_BY_ORGANIZATION_OR_DOCTOR,
  SEARCH_BY_ORGANIZATION_TYPE,
  SEARCH_BY_PATIENT,
  SEARCH_BY_TRACKING_NUMBER
} from './default';

export default [
  {
    gridItem: { xs: 12, md: 4 },
    ...SEARCH_BY_PATIENT
  },
  {
    ...SEARCH_BY_ORGANIZATION_OR_DOCTOR,
    gridItem: { xs: 12, md: 4 }
  },
  {
    ...SEARCH_BY_ORGANIZATION_TYPE,
    gridItem: { xs: 12, md: 4 }
  },
  {
    ...SEARCH_BY_TRACKING_NUMBER,
    gridItem: { xs: 12, md: 4 }
  },
  {
    ...SEARCH_BY_TRACKING_NUMBER,
    gridItem: { xs: 12, md: 4 },
    type: 'shipping_date',
    name: 'shipping_date'
  },
  {
    type: 'toggle',
    name: 'rushCaseOnly',
    label: 'Rush Case Only',
    gridItem: { xs: 12, md: 4 }
  },
  {
    type: 'group_inline',
    name: 'bundle_group',
    gridItem: { xs: 12 },
    ContainerComponent: Box,
    containerProps: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      style: { gap: 8 }
    },
    items: [
      {
        type: 'shipment_status',
        name: 'shipment_status'
      },
      {
        type: 'sorting'
      },
      {
        type: 'bundling_mode',
        name: 'bundling'
      }
    ]
  },
  {
    type: 'group_inline',
    name: 'group_b',
    gridItem: { xs: 12 },
    ContainerComponent: Box,
    containerProps: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    items: []
  },
  {
    type: 'group_inline',
    name: 'group_c',
    items: [
      {
        type: 'item',
        name: 'collapse'
      },
      {
        type: 'item',
        name: 'auto-refresh'
      },
      {
        type: 'item',
        name: 'onhold'
      },
      {
        type: 'item',
        name: 'reset_filters'
      }
    ]
  }
];
